<template lang="pug">
modal(:max-width="400") 
	.card.text-left
		.card-header
			span.fa.fa-folder.mr-2
			| Selecciona buzón de destino
			button.close(@click="cerrar") &times;
		ul.list-group
			li.list-group-item.list-group-item-action(
				v-for="buzon in listadoBuzones",
				:key="buzon.Path"
				:style="{'padding-left': (buzon.Nivel * 25) + 'px', 'cursor': 'default'}"
				@click="seleccionar(buzon)"
			)
				span.mr-2(:class="buzon.Icono")
				span {{ buzon.Nombre }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['buzones'],
	computed: {
		...mapGetters({
			buzonesAnidados: 'webmail/buzonesAnidados'
		}),
		listadoBuzones () {
			const buzones = []
			console.log(this.buzonesAnidados)
			const desplegar = (arr, nivel) => {
				arr.forEach(b => {
					buzones.push({
						Path: b.Path,
						Nombre: b.Nombre,
						Nivel: nivel,
						Icono: b.Icono
					})

					if (b.Buzones.length > 0) {
						desplegar(b.Buzones, nivel + 1)
					}
				})
			}
			desplegar(this.buzonesAnidados, 1)
			return buzones
		}
	},
	methods: {
		seleccionar (buzon) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Mover',
				mensaje: `¿Quieres mover los mensajes al buzón "${buzon.Nombre}"?`,
				callback: acepta => {
					if (acepta) {
						this.$emit('seleccion', buzon)
						this.cerrar()
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/mensajes/vistaBuzones.vue